module.exports = __webpack_public_path__ + "img/geofisica_4-3_3072.229c6c37.webp";